import React, { useEffect } from 'react';

import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
  } from "react-router-dom";

import { config } from "@fortawesome/fontawesome-svg-core";

import OnLoader from '@refere/ui-utils/ui/components/OnLoader';
import AppRoot from '@refere/ui-utils/ui/components/AppRoot';

import Home from './pages';

import { setErrorCallBack } from '@refere/ui-utils/ui/utils/fetch';

import { useHookstate } from '@hookstate/core';

import { theme } from '@refere/ui-utils/ui/styles/StylesGlobal';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

import { init } from './features/app';
import globalState from './features/global-state';

import "../node_modules/@fortawesome/fontawesome-svg-core/styles.css";

//necessário para forçar o uso do css dele, setado na página raiz
config.autoAddCss = false;

const nonceTag = document.getElementById("nonce") as HTMLInputElement;
const nonce = nonceTag.value;
const cache = createCache({
    key: 'refere-sistema',
    nonce,
    prepend: true,
  });

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<OnLoader />} />
            <Route path="/lead" element={<Home />} />
        </>
    )
  );

const GetThemeByCorretora = (corretoraTheme: string) => {
    const customTheme = theme;
    switch (corretoraTheme) {
        case "sicoob":
            customTheme.palette.primary.main = "#003E4D"

            break;
        case "ailos":
            customTheme.palette.primary.main = "#214752"

            break;
        case "unicred":
            theme.palette.primary.main = "#004C35"

            break;
        case "cresol":
            customTheme.palette.primary.main = "#13533E"

            break;
        default:
            customTheme.palette.primary.main = "#214752"

            break;
    }

    return customTheme;
}

const App = () => {
    const isLoading = useHookstate(globalState.isLoading);
    const simulacaoState = useHookstate(globalState.simulacaoState);

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        init();
    }, []);

    return (
        <CacheProvider value={cache}>
            <AppRoot 
                theme={GetThemeByCorretora(simulacaoState.corretoraNome?.get())}
                isLoading={
                    isLoading.get({noproxy:true})
                }
                setFetchErrorCallBack={setErrorCallBack}
                onFetchError={() => globalState.isLoading.set(false)}
            >
                <RouterProvider router={router} />
            </AppRoot>
        </CacheProvider>
    );
}

export default App;

